export var createSourceManager = function createSourceManager(createSource) {
  var state = {
    source: null,
    listenersByName: new Map()
  };
  return {
    addEventListener: function addEventListener(name, listener) {
      if (!state.listenersByName.size) {
        state.source = createSource();
      }

      if (!state.source) {
        throw new Error("The source doesn't exist");
      }

      var listeners = state.listenersByName.get(name) || new Set();
      listeners.add(listener);
      state.listenersByName.set(name, listeners);
      state.source.addEventListener(name, listener);
    },
    removeEventListener: function removeEventListener(name, listener) {
      if (!state.source) {
        throw new Error("The source doesn't exist");
      }

      var listeners = state.listenersByName.get(name) || new Set();
      listeners.delete(listener);

      if (!listeners.size) {
        state.listenersByName.delete(name);
      }

      state.source.removeEventListener(name, listener);

      if (!state.listenersByName.size) {
        state.source.close();
        state.source = null;
      }
    }
  };
};